import React, { useState, useEffect } from 'react';
import './DateInput.css'


const DateInput = ({ date, onChangeAction, index, maxDate, minDate }) => {
	const [dateString, setDateString] = useState('')

	useEffect(() => {
		if (!date) {
			return
		}

		let newDate = new Date(date)
		const d = newDate.getDate()
		const m = newDate.getMonth()
		const y = newDate.getFullYear()
		setDateString(`${y}-${(m + 1).toString().padStart(2, "0")}-${d.toString().padStart(2, "0")}`)
	}, [date])

	const handleDate = (value) => {
		setDateString(value)
		onChangeAction(new Date(value), index)
	}

	return <input
		className='dateInput'
		type='date'
		id={ date }
		value={ dateString }
		min={minDate}
		max={maxDate}
		onChange={ (e) => { handleDate(e.target.value) } }
	/>
}

export default DateInput
